<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">EXTRACTO DE CLIENTES</div>
    <div class="box-container">
      <div class="box-filtres">
        <table width="100%">
          <tbody>
            <tr>
              <td width="380px">CLIENTE</td>
              <td width="150px">FECHA</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <Select2
                  v-model="cliente_unique"
                  :options="clientes"
                  @select="onSelectCliente($event)"
                />
              </td>
              <td>
                <input
                  class="form-control center"
                  type="text"
                  datatype="fecha"
                  autocomplete="off"
                  id="fecha_recarga"
                  readonly="true"
                />
              </td>
              <td>
                <button
                  class="btn btn-warning"
                  type="submit"
                  v-on:click="getExtractoDeCliente"
                >
                  Consultar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table
          id="table1"
          width="100%"
          class="display nowrap"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th width="100px">Fecha</th>
              <th width="100px">Documento</th>
              <th width="100px">Recarga</th>
              <th width="100px">Producto</th>
              <th width="100px">Placa</th>
              <th width="100px">Cantidad</th>
              <th width="100px">Precio</th>
              <th width="100px">Venta</th>
              <th width="100px">Saldo</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import VehiculoService from "../Vehiculos/VehiculoService.js";
import ReporteService from "../../service/ReporteService";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";

export default {
  components: { Select2 },
  data() {
    return {
      GLOBAL,
      person: null,
      vehiculo: null,
      tercero: null,
      flota: null,
      valor_recarga: 0,
      fecha_recarga: null,
      loading: false,
      consumo: null,
      saldo: null,
      disableBotonGuardar: true,
      mensaje: "",
      reporte: [],
      acuerdo: null,
      vehiculoService: null,
      clienteService: null,
      clientes: [],
      cliente: null,
      cliente_unique: null,
      credito: {},
      flotas: [],
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.vehiculoService = new VehiculoService();
    this.clienteService = new ClienteService();

    this.credito = {};
    this.credito.flota = "";

    this.mensaje = "";
  },
  mounted() {
    $("input[datatype='fecha']").datepicker({
      onSelect: (dateText) => {
        this.actualizaComponente(dateText);
      },
    });
    this.getListaCliente();
  },
  methods: {
    actualizaComponente(selected) {
      this.fecha_recarga = selected;
    },

    onSelectCliente({ id, text }) {
      for (var i in this.clientes) {
        if (this.clientes[i].id == this.cliente_unique) {
          this.cliente = this.clientes[i];
          this.cliente._id = this.clientes[i].id;
          break;
        }
      }
    },

    getListaCliente() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          console.log(data);

          this.clientes = [];
          for (var i in data) {
            this.clientes.push({
              id: data[i]._id,
              text: data[i].nombres,
              nit: data[i].identificacion,
              nombres: data[i].nombres,
            });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    getExtractoDeCliente() {
      this.reporte = [];
      this.loading = true;
      this.clienteService
        .getExtractoDeCliente(
          this.person,
          this.cliente_unique,
          this.fecha_recarga
        )
        .then((response) => {
          console.log(response);
          this.reporte = response;
        })
        .then(() => {
          //FIX: en este orden soluciona el problema de datatable repetida//
          try {
            $("#table1").DataTable().destroy();
          } catch (error) {}
          $("#containter-table").html(this.table);

          const boxes = document.querySelectorAll(".btt");
          boxes.forEach((box) => {
            box.remove();
          });

          //END FIX://
          var vm = this;
          $("#table1").DataTable({
            data: this.reporte,
            columns: [
              { data: "fecha" },
              { data: "recibo" },
              {
                class: "text-right",
                render: function (data, type, row) {
                  return row.recarga == null
                    ? ""
                    : GLOBAL.FORMATO_MONEY_BASIC(row.recarga);
                },
              },
              {
                render: function (data, type, row) {
                  return row.placa == null ? "" : row.placa;
                },
              },
              {
                render: function (data, type, row) {
                  return row.producto == null ? "" : row.producto;
                },
              },
              {
                render: function (data, type, row) {
                  return row.cantidad == null ? "" : row.cantidad;
                },
              },
              {
                class: "text-right",
                render: function (data, type, row) {
                  return row.precio == null
                    ? ""
                    : GLOBAL.FORMATO_MONEY_BASIC(row.precio);
                },
              },
              {
                class: "text-right",
                render: function (data, type, row) {
                  return row.venta == null
                    ? ""
                    : GLOBAL.FORMATO_MONEY(row.venta);
                },
              },
              {
                class: "text-right",
                render: function (data, type, row) {
                  return row.saldo == null
                    ? ""
                    : GLOBAL.FORMATO_MONEY(row.saldo);
                },
              },
            ],
            dom:
              "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
              "<'row'<'col-sm-12'tr>>" +
              "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
            buttons: [
              {
                extend: "copyHtml5",
                text: '<i class="fa-regular fa-clipboard"></i>',
              },
              {
                extend: "excelHtml5",
                text: '<i class="fa-regular fa-file-excel"></i>',
              },
              {
                extend: "csvHtml5",
                text: '<i class="fa-solid fa-file-csv"></i>',
              },
              {
                extend: "pdfHtml5",
                text: '<i class="fa-regular fa-file-pdf"></i>',
              },
            ],
            responsive: false,
            scrollX: true,
            lengthMenu: [
              [10, 20, 50, -1],
              [10, 20, 50, "Todos"],
            ],
            language: {
              url: "plugins/Spanish.json",
            },
          });
          this.loading = false;

          var vm = this;
          $("#table1 tbody").off("click");
          $("#table1 tbody").on("click", "#edit", vm, function () {
            let id = $(this).data("id");
            vm.openMe(id);
          });
        });
    },
  },
};
</script>
